//Popups designed to be used with bootstrap.  
//
//
//methods:
//  open(options) - opens a popup
//  close($popup) - closes the popup, $popup is a jQuery object passed to the various callback functions.
//
//
//options:
//  type: shows the popup, types are "alert", "confirm", "generic".  Default is generic
//  title: the popup title,
//  content:  the content for the popup
//  css: additional css class for popup
//  width: optional, width of popup in pixels.  Use classes defined by limitless on cssClass property
//  style
//  okButtonText: optional, text for primary button, default is ok
//  buttons: optional, see below
//  noHeader: if true, the header/title area is suppressed.
//  noFooter: if true, the footer/buttons are suppressed.
//
//callbacks:  callbacks are part of options.  All callbacks are passed a $popup object that is the jQuery popup.
//  afterOpen: called after the popup is shown
//  afterClose: called after the popup is hidden and before it is destroyed
//  okCallback:  called after OK or Save is clicked and before the popup is closed.  Return false to keep the popup open.
//      Note:  when returning false, the buttons are disabled.  You must call delta.popup.enableButtons($popup) to
//             re-enable them.
//  cancelCallback: called after Cancel of the top X button is clicked and before the popup is closed.  Return false to keep the popup open.
//
//types:
//  alert
//      Close button, fires cancelCallback
//  confirm
//      Ok button, fires okCallback
//      Cancel, fires cancelCallback
//  generic
//      buttons must be provided manually
//
//buttons: custom buttons can be specified for "generic" popups.  
//buttons: [
//  {
//      text: text or html for button,
//      isOk: true for Ok button, fires okCallback.  
//      isCancel: true for cancel button, fires cancelCallback
//      isPrimary: default to true if isOk=true, otherwise default to false.  If true class="btn-primary" is added.
//      width: default is null, useful if you want all buttons to be the same size.
//      callback: custom functions for buttons when isOk=false and isCancel=false, ignored if isOk=true or isCancel=true.  
//                $popup is passed to custom functions.
//      leftAlign: default is false
//      cssClass: default is null; used to apply one or more css classes to the button element
//  },
//  {another button}
//]

var delta = delta || {};
delta.popup = function() {
    var

    //
    //open the popup
    //
    openPopup = function(options) {
        //merge the settings
        getSettings(
            options,
            function (settings) {
                //create the popup
                var $popup = createPopup(settings);

                //define the buttons
                defineButtons(settings);

                //add the buttons and events
                setupButtons($popup, settings);


                //show it
                $popup.modal("show");

                //kill focus so it enter key doesn't affect old control
                $(':focus').blur();

                //draggable
                $popup.draggable({
                    handle: ".modal-header",
                });

                //afterOpen callback
                if (settings.afterOpen) {
                    settings.afterOpen($popup);
                }
            }
        )
    },


    //
    //close the popup.  This is used when you need to close it manually, $popup is the model popup returned by the 
    //various callback functions.
    //
    closePopup = function($popup) {
        $popup.modal("hide");
    },


    //
    //private method to retrieve the default settings and merge the user options.
    //
    getSettings = function(options, callback) {
        //defult settings for options.  We're defining them all here but some are not used by some popups.
        var defaults = {
            type: "generic",
            title: null,
            content:  null,
            css: null,
            width: null,
            style: null,
            afterOpen: null,
            afterClosed: null,
            okCallback:  null,
            cancelCallback: null,
            buttons: null,
            cssClass: null,      //css class added to modal
            okButtonText: null,
            noHeader: false,
            noFooter: false,
            sourceId: null
        };

        //merge the options and defaults
        var settings = $.extend({}, defaults, options);

        if (settings.okButtonText == null || settings.okButtonText == '') {
            settings.okButtonText = 'Ok';
        }

        callback(settings);
    },


    //
    //helper method to create the popup
    //
        createPopup = function (settings) {
            //need to find an unused id
            var cnt = 0;
            var id = "";
            do { id = `autoPopup_${cnt++}` } while ($(`#${id}`).length > 0)

            //create the popup html
            var s = `<div id="${id}" class="modal show fade ${settings.cssClass}" ${settings.sourceId===null ? '' : `data-source-id="${settings.sourceId}"`}><div class="modal-dialog modal-dialog-centered modal-dialog-scrollable ${settings.css}"><div class="modal-content">`;

            //create the header
            if (!settings.noHeader) {
                s += `<div class="modal-header"><h3 class="modal-title text-truncate">${settings.title}</h3></div>`;
            }

            //create the modal body
            s += `<div class='modal-body'>${settings.content}</div>`;

            //create the footer, and buttons
            if (!settings.noFooter) {
                s += "<div class='modal-footer'></div>";
            }

            //close the main div.modal
            s += "</div></div></div>";

            //add it to the body and prevent body selection
            $(document.body).append(s);

            //get a reference to the modal div we just added and create the modal object
            var $popup = $(`#${id}`);
            $popup.modal({ keyboard: false, backdrop: 'static' });

        //hookup the hidden event to remove it
        $popup.on("hidden.bs.modal", function() {
            //after closed callback
            if (settings.afterClose) {
                settings.afterClose($popup);
            }

            //remove it
            $popup.remove();
        });

        //return the opener
        return $popup;
    },
    
    //
    //define the buttons for the popup
    //
    defineButtons = function(settings) {
        if (settings.type == "alert") {
            //alert box buttons
            settings.buttons = [
                {text: settings.okButtonText, isOk: true, isPrimary: true}
            ];
        } else if (settings.type == "confirm") {
            //confirm box buttons
            settings.buttons = [
                {text: "Cancel", isCancel: true},
                {text: settings.okButtonText, isOk: true, isPrimary: true}
            ];
        }

        //merge the buttons with default values so they have all props defined
        if (settings.buttons) {
            var defaults = {text:null, isOk:false, isCancel:false, isPrimary:false, width:null, callback: null, leftAlign: false, cssClass:null};
            for(var i=0; i<settings.buttons.length; i++) {
                settings.buttons[i] = $.extend({}, defaults, settings.buttons[i]);
            }
        }
    },
    
    //
    //add the buttons to the popup and setup the events
    //
    setupButtons = function($popup, settings) {
        //get the footer
        var $footer = $popup.find(".modal-footer");

        //create each button and add it
        if (settings.buttons) {
            for(var i=0; i<settings.buttons.length; i++) {
                var b = settings.buttons[i];

                var $btn = $("<button class='btn' type='button' data-btn-index='" + i + "'>" + b.text + "</button>");

                if (b.isPrimary) {
                    $btn.addClass("btn-primary");
                } else {
                    $btn.addClass("btn-light");
                }
                if (b.isCancel) {
                    $btn.attr("data-dismiss", "modal");
                }
                if (b.width) {
                    $btn.css("width", b.width + "px");
                }
                //add data- attributes if isOk or isCancel
                if (b.isOk) {
                    $btn.attr("data-btn-type", "ok");
                }
                if (b.isCancel) {
                    $btn.attr("data-btn-type", "cancel");
                    $btn.attr('data-bs-dismiss', 'modal');
                }
                if (b.leftAlign) {
                    $btn.addClass('float-start');
                }
                if (b.cssClass){
                    $btn.addClass(b.cssClass)
                }

                //add to the footer
                $footer.append($btn);

                //add the custom function, on if !isOk and !isCancel
                if (!b.isOk && !b.isCancel && b.callback != null) {
                    $btn.click(function() {
                        //Disabled all the button to prevent the user to click on post
                        $('.modal-footer button').attr('disabled', 'disabled');

                        //get the index
                        var idx = parseInt($(this).attr("data-btn-index"));

                        //need to call using original array, since this won't execute until later it will have a value of b that is the last 
                        //element of the index
                        settings.buttons[idx].callback($popup);
                    });
                }
            }
        }

        //cancelCallback
        if (settings.cancelCallback) {
            //need to hookup to any cancel buttons and the top X in the header
            //there may be multiple buttons
            var $cancel = $popup.find(".modal-header button[data-btn-type='cancel'], .modal-footer button[data-btn-type='cancel']");

            //remove the auto-close mechanism
            $cancel.removeAttr("data-dismiss");

            //hookup the click function
            $cancel.click(function() {
                //disable the buttons
                $cancel.attr("disabled", true);

                //close flag
                var close = true;

                //callback
                if (settings.cancelCallback($popup) == false) {
                    close = false;
                }

                //close or re-enable the buttons
                if (close) {
                    //close
                    $popup.modal("hide");
                } else {
                    //enable the buttons
                    $cancel.attr("disabled", false);
                }
            });
        }

        //get the ok button, there may be multiples
        var $ok = $popup.find(".modal-footer button[data-btn-type='ok']");

        //if any found
        if ($ok.length > 0) {
            //hookup click
            $ok.click(function() {
                //close flag
                var close = true;

                //callback
                if (settings.okCallback) {
                    //disable the button
                    $ok.attr("disabled", true);

                    //call it
                    if (settings.okCallback($popup) == false) {
                        close = false;
                    }
                }

                //close
                if (close) {
                    $popup.modal("hide");
                } else {
                    //disable all buttons
                    $popup.find('.modal-footer button').attr('disabled', true);
                }
            });
        }
    }
        
    enableButtons = function($popup) {
       $popup.find('.modal-footer button').attr('disabled', false);
    };
    
    


    //return methods
    return {
        open: openPopup,
        close: closePopup,
        enableButtons: enableButtons
    };
}();